import React from "react";

export const Section = ({ children, className = "", ...props }) => (
  <section className={`max-w-7xl mx-auto px-4 sm:px-6 ${className}`} {...props}>{children}</section>
);

export const Eyebrow = ({ children }) => (
  <span className="eti-label inline-block mb-3">{children}</span>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-tight text-white ${className}`}>{children}</h2>
);

export const currency = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);
